import { IManhattanBundleState } from "./types";
import ActionTypes from "../../../../constants/ActionTypes";

const initialState: IManhattanBundleState = {
  bundle: {}
};

const bundleReducer = (
  state = initialState,
  action: any,
): any => {
  switch (action.type) {
  case ActionTypes.MANHATTAN.BUNDLE.SET:
    return {
      ...state,
      bundle: action.payload,
    };
  }
  return state;
};

export default bundleReducer;

